<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="8">
        <el-card>
          <div slot="header">
            新消息
          </div>
          <div class="statistics">
            <bean-link :to="{ name: 'normal_comments.index', query: { admin_read_eq: false, page: 1 } }">{{ data.unread_comments_count }}</bean-link>
          </div>
        </el-card>
      </el-col>
      <!-- <el-col :span="6">
        <el-card>
          <div slot="header">
            报名申请退款数
          </div>
          <div class="statistics">
            <bean-link :to="{ name: 'apply_records.index', query: { state_eq: 'refund_audit' } }">{{ data.refund_audit_apply_records_count}}</bean-link>
          </div>
        </el-card>
      </el-col> -->
      <el-col :span="8">
        <el-card>
          <div slot="header">
            新增用户（昨日）
          </div>
          <div class="statistics">
            <bean-link :to="{ name: 'users.index' }">{{ data.yesterday_users_count }}</bean-link>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card>
          <div slot="header">
            总用户数
          </div>
          <div class="statistics">
            <bean-link :to="{ name: 'users.index' }">{{ data.users_count }}</bean-link>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :span="6">
        <el-card>
          <div slot="header">
            周活跃用户数
          </div>
          <div class="statistics">
            <bean-link :to="{ name: 'users.index' }">{{ data.weekly_active_users_count }}</bean-link>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <div slot="header">
            周活跃青训营学员数
          </div>
          <div class="statistics">
            <bean-link :to="{ name: 'users.index' }">{{ data.weekly_active_students_count}}</bean-link>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <div slot="header">
            月活跃用户数
          </div>
          <div class="statistics">
            <bean-link :to="{ name: 'users.index' }">{{ data.monthly_active_users_count }}</bean-link>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <div slot="header">
            月活跃青训营学员数
          </div>
          <div class="statistics">
            <bean-link :to="{ name: 'users.index' }">{{ data.monthly_active_students_count }}</bean-link>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :span="24">
        <el-card>
          <div slot="header">
            昨日阅读 Top 3
          </div>
          <div>
            <li v-for="post in data.yesterday_top_3_posts" :key="post.id">
              <bean-link keepNode :to="linkTo(post)">{{post.title}}</bean-link>
            </li>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!-- <el-row :gutter="15">
      <el-col :span="12">
        <el-card>
          <div slot="header">
            报名支付数趋势图
          </div>
          <div>
            <ECharts :options="applyRecordPaidTrendLineOptions" style="width:100%" />
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div slot="header">
            报名支付/退款金额趋势图
          </div>
          <div>
            <ECharts :options="paymentTrendLineOptions" style="width:100%" />
          </div>
        </el-card>
      </el-col>
    </el-row> -->
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import _ from 'lodash';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/legendScroll';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/title';
import pluralize from 'pluralize';

@Component({
  components: {
    ECharts
  }
})
export default class ApplicationHome extends Vue {
  data = {
    users_count: 0,
    refund_audit_apply_records_count: 0,
    apply_records_count: 0,
    new_users_trend: [],
    apply_record_paid_trend: [],
    charge_payment_completed_amount_trend: [],
    refund_payment_completed_amount_trend: [],
    yesterday_top_3_posts: [],
  }

  chartBaseConfig = {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: []
    },
    xAxis: {
      type: 'category',
      data: []
    },
    yAxis: {
      type: 'value'
    },
    series: []
  }

  async mounted() {
    this.data = await this.$request.get('/dashboard/application')
  }

  get newUsersTrendLineOptions() {
    const legendData = ['新用户数']

    return _.merge({}, this.chartBaseConfig, {
      legend: {
        data: legendData
      },
      xAxis: {
        data: Object.keys(this.data.new_users_trend)
      },
      yAxis: {
        minInterval: 1
      },
      series: _.map([
        this.data.new_users_trend,
      ], (element, index) => {
        return {
          name: legendData[index],
          type: 'line',
          data: Object.values(element)
        }
      })
    })
  }

  get applyRecordPaidTrendLineOptions() {
    const legendData = ['报名支付']

    return _.merge({}, this.chartBaseConfig, {
      legend: {
        data: legendData
      },
      xAxis: {
        data: Object.keys(this.data.new_users_trend)
      },
      yAxis: {
        minInterval: 1
      },
      series: _.map([
        this.data.apply_record_paid_trend,
      ], (element, index) => {
        return {
          name: legendData[index],
          type: 'line',
          data: Object.values(element)
        }
      })
    })
  }

  get paymentTrendLineOptions() {
    const legendData = ['支付金额', '退款金额']

    return _.merge({}, this.chartBaseConfig, {
      legend: {
        data: legendData
      },
      xAxis: {
        data: Object.keys(this.data.new_users_trend)
      },
      yAxis: {
        minInterval: 0.01
      },
      series: _.map([
        this.data.charge_payment_completed_amount_trend,
        this.data.refund_payment_completed_amount_trend,
      ], (element, index) => {
        return {
          name: legendData[index],
          type: 'line',
          data: Object.values(element)
        }
      })
    })
  }

  linkTo(item) {
    return { name: `${pluralize(_.snakeCase(item.cn))}.show`, params: { id: item.id } }
  }
}
</script>
